import { render, staticRenderFns } from "./IconTag.vue?vue&type=template&id=4c1633c4&"
import script from "./IconTag.vue?vue&type=script&lang=js&"
export * from "./IconTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1633c4')) {
      api.createRecord('4c1633c4', component.options)
    } else {
      api.reload('4c1633c4', component.options)
    }
    module.hot.accept("./IconTag.vue?vue&type=template&id=4c1633c4&", function () {
      api.rerender('4c1633c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTag.vue"
export default component.exports